import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import LocationsListTable from '../../../sub_components/tables/LocationsList';
// import { SearchInput } from '../../../reusables/Inputs';
import EmployerDetailsLayout from '../../../layouts/details/Employer';
import { SVGIcon } from '../../../wrappers/SVGIcon';

import useGetLocations from '../../../../hooks/locations/useGetLocations';
import useGetEmployerDetails from '../../../../hooks/employers/useGetEmployerDetails';

import { Icons } from '../../../../data/Assets';

import { ISortQuery } from '../../../../interfaces/services';

const LocationsPage = () => {
    const { employer_id } = useParams();
    const navigate = useNavigate();

    const [sortQuery, setSortQuery] = useState<ISortQuery>({ sort_key: 'identifier', sort_order: 'ASC' });

    const { data: employer } = useGetEmployerDetails(employer_id);
    const { data: locations, isLoading } = useGetLocations('employer', employer_id, sortQuery);

    return (
        <EmployerDetailsLayout
            operation={null}
            currentTab="Locations"
            title={employer?.legal_name ?? 'Employer Information'}
            error={false}
        >
            <div className="immployer__lists__page_view">
                <br />
                <div className="immployer__lists__top_section">
                    {/* <SearchInput /> */}
                    <button
                        onClick={() => navigate(`/employers/${employer_id}/locations/new`)}
                        className="immployer__btn immployer__btn__primary"
                    >
                        <SVGIcon src={Icons.Plus} color='white' />
                        <span>Add&nbsp;Location</span>
                    </button>
                </div>
                <LocationsListTable
                    locations={locations ?? []}
                    isLoading={isLoading}
                    sortQuery={sortQuery}
                    setSortQuery={setSortQuery}
                />
            </div>
        </EmployerDetailsLayout>
    );
};

export default LocationsPage;